import type { KeyboardEvent } from 'react';

/** Marks a field in the Return order: numbers, text boxes and the desk's drop-downs, in screen order. */
const FIELD_ATTRIBUTE = 'data-measure-field';

/** Spread onto a field to put it in the Return order. */
export const IN_FIELD_ORDER = { [FIELD_ATTRIBUTE]: '' };

/**
 * Tab, Shift-Tab and Return move to the next / previous field ourselves. On
 * the iPad with a Magic Keyboard Return works through this, but Tab doesn't —
 * its keydown appears never to reach the page (DD, 2026-10-08; iPadOS or the
 * full-screen web clip, not established). Return is the documented way.
 * Return in a several-line box types a new line. At the first or last field
 * it is left to the browser, or with `blurAtEnd` Return closes the keyboard.
 */
export function moveToNextField(event: KeyboardEvent<HTMLElement>, blurAtEnd = false) {
  if (event.key !== 'Tab' && event.key !== 'Enter') return;
  if (event.key === 'Enter' && event.currentTarget instanceof HTMLTextAreaElement) return;
  const fields = Array.from(document.querySelectorAll<HTMLElement>(`[${FIELD_ATTRIBUTE}]`)).filter((f) => f === event.currentTarget || !f.matches(':disabled'));
  const target = fields[fields.indexOf(event.currentTarget) + (event.shiftKey ? -1 : 1)];
  if (!target) {
    if (blurAtEnd && event.key === 'Enter') event.currentTarget.blur();
    return;
  }
  event.preventDefault();
  target.focus();
  if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) return;
  // A number is selected, so typing replaces it (#388); text keeps what's there and types on at the end.
  if (target.inputMode === 'decimal') target.select();
  else target.setSelectionRange(target.value.length, target.value.length);
}
